/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Push_OffInputs */

const en_us2_profile_push_off = /** @type {(inputs: Profile_Push_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Off: nothing arrives on this device.`)
};

const pt_br2_profile_push_off = /** @type {(inputs: Profile_Push_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desligadas: nada chega neste aparelho.`)
};

const es_419_profile_push_off = /** @type {(inputs: Profile_Push_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desactivadas: no llega nada a este dispositivo.`)
};

const pt_pt2_profile_push_off = /** @type {(inputs: Profile_Push_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desligadas: nada chega a este dispositivo.`)
};

const fr_fr2_profile_push_off = /** @type {(inputs: Profile_Push_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Désactivées : rien n'arrive sur cet appareil.`)
};

const de_de2_profile_push_off = /** @type {(inputs: Profile_Push_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aus: Auf diesem Gerät kommt nichts an.`)
};

const it_it2_profile_push_off = /** @type {(inputs: Profile_Push_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disattivate: su questo dispositivo non arriva nulla.`)
};

/**
* | output |
* | --- |
* | "Off: nothing arrives on this device." |
*
* @param {Profile_Push_OffInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_push_off = /** @type {((inputs?: Profile_Push_OffInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Push_OffInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_push_off(inputs)
	if (locale === "es-419") return es_419_profile_push_off(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_push_off(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_push_off(inputs)
	if (locale === "de-DE") return de_de2_profile_push_off(inputs)
	if (locale === "it-IT") return it_it2_profile_push_off(inputs)
	return en_us2_profile_push_off(inputs)
});
export { profile_push_off as "profile.push_off" }